import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
// import { isNumber } from 'util';

enum monthList {
  Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec
}

@Injectable({
  providedIn: 'root'
})
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {

  parse(value: string): NgbDateStruct {
    if (value && value !== undefined) {
      const dateParts = value.trim().split('-');
      if (dateParts.length === 1) {
        return {day: parseInt(dateParts[0], 10), month: null, year: null};
      } else if (dateParts.length === 2) {
        const monthNum = monthList[dateParts[1]] + 1;
        return {day: parseInt(dateParts[0], 10), month: monthNum, year: null};
      } else if (dateParts.length === 3) {
        const monthNum = monthList[dateParts[1]] + 1;
        return {day: parseInt(dateParts[0], 10), month: monthNum, year: parseInt(dateParts[2], 10)};
      }
    }
    return null;
  }

  format(date: NgbDateStruct): string {
    if (date) {
      const dateObj = new Date(date.year, date.month - 1, date.day).toString().split(' ');
      return date ?
        `${!isNaN(date.day) ? date.day : ''}-${!isNaN(date.month) ? dateObj[1] : ''}-${date.year}` :
        '';
    } else {
      return null;
    }
  }
}
